"use client";

/**
 * The shop page's Games tab (opened from BrandsHeroSection): the shop's games
 * in three groups, Open now / Coming up / Results (Games v2). Each game has
 * its own page at /games/<id>, where it's played.
 */
import GamesList from "@/components/games/v2/GamesList";
import type { Id } from "@/convex/_generated/dataModel";

interface GamesTabContentProps {
  brandId: string; // Convex brand ID
  domain: string;
}

export default function GamesTabContent({ brandId }: GamesTabContentProps) {
  return (
    <div className="mx-auto w-full max-w-3xl px-2 pb-10 pt-2 sm:px-4">
      <h2 className="mb-4 pr-14 text-xl font-extrabold leading-tight" style={{ color: "#0f172a" }}>
        Games
      </h2>
      {brandId ? (
        <GamesList brandId={brandId as Id<"brands">} />
      ) : (
        <p className="py-10 text-center text-sm" style={{ color: "#64748b" }}>
          No games right now.
        </p>
      )}
    </div>
  );
}
